export const regEx = {
    MATCHES_WITH_SUFFIX: /(\[Matches)(.*?)(?:\])/,
    DATES_WITH_SUFFIX: /(\[Dates)(.*?)(?:\])/,
    ME_WITH_SUFFIX: /(\[Me)(.*?)(?:\])/,
    MATCHES: /(\[Matches)(?:\])/,
    DATES: /(\[Dates)(?:\])/,
    ME: /(\[Me)(?:\])/,
    DATETIME: /(0?[1-9]|1[0-2])\/(0?[1-9]|[12][0-9]|3[01])\/\d\d\d\d, (00|[0-9]|1[0-9]|2[0-3]):([0-9]|[0-5][0-9]):([0-9]|[0-5][0-9]) (AM|PM)/g,
    REPLY:/\[Reply\].*$/g,
    QUOTE:/\[Quote\]/
}